import { atom } from 'jotai'

import { IApprovalDetailChildItem, IBulkApprovalsData } from '@/types/tasksApprovals'

export const selectedOptionForAllAtom = atom<'reject' | 'approve' | 'mixed' | null>(null)
export const rejectReasonForAllAtom = atom('')
export const childItemsAtom = atom<IApprovalDetailChildItem[]>([])

export const generateDataforBuklApproval = (items: IApprovalDetailChildItem[]) => {
    const bulkApprovalData: IBulkApprovalsData[] = []
    items.map((_item) => {
        const itemData: IBulkApprovalsData = {
            itemId: _item.approval_entity_id.toString(),
            approve: _item.isApproved,
            rejectionReason: _item.rejectReason,
        }

        bulkApprovalData.push(itemData)
    })

    return bulkApprovalData
}
